import React, { useEffect, useRef, useState } from "react";
import Header from "../../common/Header";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Title from "./Title";
import Timeline from "./Timeline";
import Comment from "./Comment";
import Information from "./Information";
import axios from "axios";
import styled from "styled-components";
// import { partsInfoAtom } from "../../common/atoms.js";
// import { useRecoilState } from "recoil";
import { Button } from "devextreme-react";
import * as goBackIcon from "./goback.svg";
import { toastMsg } from "../utils";

const QnADetailWrapper = styled.main`
  margin: 40px auto;
  width: 1520px;
  max-width: 98vw;
  > div:not(:first-child) {
    display: flex;
    > div:first-child {
      display: flex;
      flex-direction: column;
      width: calc(100% - 375px);
      margin-right: 80px;
    }
    > div:last-child {
      width: 295px;
    }
  }
`;
const GoBackBtn = styled(Button)`
  margin: 0;
  border-radius: 5px !important;
  margin: 0px 0px 0px 8px;
  min-width: 26px;
  float: right;
  padding: 0;
  img {
    width: 16px;
    height: 16px;
  }
`;
const ButtonArea = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  #submitBtn,
  #cancelBtn {
    margin: 16px 0px 0px 16px;
    font-size: 16px;
    border-radius: 10px;
    border: 3px solid #7fba4c;
    padding: 3px 0px;
    &:not(.dx-button-mode-outlined) {
      background-color: #7fba4c;
    }
    .dx-button-text {
      font-weight: bold;
    }
  }
  #cancelBtn .dx-button-text {
    color: black;
  }
`;

const QnADetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [detailsData, setDetailsData] = useState(null);
  const [mode, setMode] = useState("view");
  const [partsInfo, setPartsInfo] = useState(null);
  const userInfo = useSelector((state) => state.userInfo);

  const isAuthor = useRef(false);
  const catRef = useRef(null);
  const cmtRef = useRef(null);
  const titleRef = useRef(null);
  const topicRef = useRef(null);

  useEffect(() => {
    // setDetailsData, setAuthor
    if (id !== "new") {
      axios
        .get(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/${id}`)
        .then((res) => {
          // 로그인 사용자와 글 작성자가 같은지 확인
          if (res.data.msgs[1].au === userInfo.employeeNo) {
            isAuthor.current = true;
          }
          return res.data;
        })
        .then((data) => {
          setDetailsData(data);
        })
        .catch((err) => {
          throw err;
        });

      // setPartsInfo
      axios
        .get(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/pax/${id}`)
        .then((res) => {
          setPartsInfo(res.data);
        })
        .catch((err) => {
          throw err;
        });
    }

    // setMode
    if (id === "new") {
      setMode("create");
    } else if (userInfo.div === "SRD") {
      setMode("admin");
    }
  }, [id]);

  const extractQuotedSEQ = (cmt) => {
    const quoteBoxes = new DOMParser().parseFromString(cmt, "text/html").querySelectorAll("span.quote-box");
    const result = [];
    quoteBoxes.forEach((el) => {
      result.push(el.getAttribute("data-id"));
    });
    return result.length ? result.join(",") : null;
  };

  const onNavigateToBoard = () => {
    navigate("/qna");
  };

  const onSubmitMsg = (e) => {
    if (mode === "create") {
      const validationResult = e.validationGroup.validate().isValid;
      if (validationResult) {
        axios
          .post(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/null/null`, {
            topic: topicRef.current.instance.option("value"),
            cat: catRef.current.instance.option("value"),
            title: titleRef.current.instance.option("value"),
            descr: cmtRef.current.instance.option("value"),
            au: userInfo.employeeNo,
          })
          .then((res) => {
            toastMsg(`게시글이 등록되었습니다.`, true);
            navigate(`/qna/${res.data.id}`);
          })
          .catch((err) => {
            toastMsg(`에러가 발생했습니다. 관리자에게 문의해주세요.`, false);
            throw err;
          });
      }
    } else {
      const validationResult = e.validationGroup.validators.reduce((res, ele) => {
        if (ele._$element[0].id === "cmtEditor") {
          const { isValid } = ele.validate();
          res = isValid;
        }
        return res;
      }, true);

      const dReply = extractQuotedSEQ(cmtRef.current.instance.option("value"));
      if (validationResult) {
        axios
          .post(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/${id}/${dReply}`, {
            descr: cmtRef.current.instance.option("value"),
            au: userInfo.employeeNo,
          })
          .then((res) => {
            setDetailsData(res.data);
            toastMsg(`답글이 등록되었습니다.`, true);
            // 답글 등록 후 참여자 정보 업데이트
            axios
              .get(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/pax/${id}`)
              .then((res) => {
                setPartsInfo(res.data);
                // 답글 내용 지우기
                e.validationGroup.reset();
              })
              .catch((err) => {
                throw err;
              });
          })
          .catch((err) => {
            toastMsg(`에러가 발생했습니다. 관리자에게 문의해주세요.`, false);
            throw err;
          });
      }
    }
  };

  return (
    <React.Fragment>
      <Header title={"QnA"} menuDataSource={null} />
      <QnADetailWrapper>
        <GoBackBtn
          id="goBackBtn"
          width={26}
          height={26}
          icon={`${goBackIcon.default}`}
          stylingMode="contained"
          onClick={onNavigateToBoard}
        />
        {mode === "create" && (
          <>
            <Title mode={mode} titleRef={titleRef} />
            <div>
              <div>
                <Comment cmtRef={cmtRef} mode={mode} userInfo={userInfo} />
                <ButtonArea>
                  <Button
                    id="submitBtn"
                    height={34}
                    stylingMode="contained"
                    text="제출하기"
                    type="success"
                    onClick={onSubmitMsg}
                    width={105}
                  />
                  <Button
                    id="cancelBtn"
                    height={34}
                    stylingMode="outlined"
                    text="취소하기"
                    type="success"
                    onClick={onNavigateToBoard}
                    width={105}
                  />
                </ButtonArea>
              </div>
              <Information catRef={catRef} mode={mode} topicRef={topicRef} />
            </div>
          </>
        )}
        {
          // moode === "view" or "admin"
          detailsData && partsInfo && (
            <>
              <Title
                au={userInfo.employeeNo}
                id={id}
                isAuthor={isAuthor.current}
                mode={mode}
                status={detailsData.status}
                title={detailsData.title}
                titleRef={titleRef}
              />
              <div>
                <div>
                  <Timeline
                    cmtRef={cmtRef}
                    id={id}
                    mode={mode}
                    msgs={detailsData.msgs}
                    msgsOrder={detailsData.msgsOrder.split(",")}
                    setDetailsData={setDetailsData}
                    status={detailsData.status}
                  />
                  {(detailsData.status === "1" || detailsData.status === "2") && (
                    <>
                      <Comment cmtRef={cmtRef} mode={mode} userInfo={userInfo} />
                      <ButtonArea>
                        <Button
                          id="submitBtn"
                          height={34}
                          stylingMode="contained"
                          text="제출하기"
                          type="success"
                          onClick={onSubmitMsg}
                          width={105}
                        />
                      </ButtonArea>
                    </>
                  )}
                </div>
                <Information
                  cat={detailsData.cat}
                  catRef={catRef}
                  id={id}
                  isAuthor={isAuthor.current}
                  mode={mode}
                  parts={Object.keys(partsInfo)}
                  setDetailsData={setDetailsData}
                  setPartsInfo={setPartsInfo}
                  status={detailsData.status}
                  topic={detailsData.topic}
                  topicRef={topicRef}
                />
              </div>
            </>
          )
        }
      </QnADetailWrapper>
    </React.Fragment>
  );
};

export default QnADetail;
